var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#272726"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.648c-2.715 0-4.924-2.164-4.924-4.824C3.076 2.164 5.286 0 8 0c2.715 0 4.924 2.164 4.924 4.824 0 2.66-2.21 4.824-4.924 4.824zm0-8.094c-1.84 0-3.337 1.467-3.337 3.27S6.16 8.094 8 8.094s3.337-1.467 3.337-3.27S9.84 1.554 8 1.554zM11.077 19.958H4.923C2.21 19.958 0 17.794 0 15.134c0-2.66 2.209-4.824 4.923-4.824h6.154c2.714 0 4.923 2.164 4.923 4.824 0 2.66-2.209 4.824-4.923 4.824zm-6.154-8.094c-1.84 0-3.337 1.467-3.337 3.27s1.497 3.27 3.337 3.27h6.154c1.84 0 3.337-1.467 3.337-3.27s-1.497-3.27-3.337-3.27H4.923z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.094 15.069c2.232 0 4.048 1.78 4.048 3.965 0 2.187-1.816 3.966-4.048 3.966-2.231 0-4.047-1.779-4.047-3.966 0-2.186 1.816-3.965 4.047-3.965z",
    stroke: "#272726",
    strokeWidth: 0.8,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.662 18.7H8.408V17.47a.31.31 0 0 0-.314-.307.31.31 0 0 0-.313.307V18.7H6.527a.31.31 0 0 0-.314.307c0 .17.14.307.314.307h1.254v1.229c0 .17.14.307.313.307a.31.31 0 0 0 .314-.307v-1.229h1.254a.31.31 0 0 0 .313-.307.31.31 0 0 0-.313-.307z",
    fill: "#272726"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAccount);
export default __webpack_public_path__ + "static/media/add_account.c4aeb068a87981d32e1ddbc6fde156f8.svg";
export { ForwardRef as ReactComponent };